<template>
  <sweet-modal ref="modal-shift-work" :title="'เลือกกะการทำงาน'" overlay-theme="dark" style="z-index: 1030;">
    <div class="panel-body form-horizontal">
      <form @submit.prevent="submitShiftWorkType">
        <div class="form-group pl-3" v-if="currentShiftWork">
          <label for="current_shift_work">ปัจจุบันอยู่ในกะ <span class="font-weight-bold">{{ currentShiftWork }}</span></label>
          <br>
          <label for="current_shift_work">ฝ่ายการทำงาน:
            <span class="font-weight-bold" v-if="admin && admin.shift_work_role">
              {{ admin.shift_work_role === 'beneat_provider' ? 'BeNeat Provider' : 'BeNeat Customer' }}
            </span>
          </label>
        </div>

        <div class="form-group pl-3">
          <label for="">เลือกกะการทำงาน</label>
          <select name="shift-work" id="shift-work" class="form-control" required v-model="shiftWorkTypeSelected">
            <option :value="null">เลือกกะการทำงาน</option>
            <template v-for="(item, index) in shift_work_types">
              <option :value="item.id" :key="index">{{ item.name }}</option>
            </template>
          </select>
        </div>

        <div class="form-group pl-3">
          <p>บทบาทการทำงาน</p>

          <b-form-radio-group
            v-model="roleSelected"
            :options="roleOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            required
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </div>

        <div class="form-group">
          <div class="text-right">
            <button class="btn btn-primary mt-3">บันทึก</button>
          </div>

        </div>
      </form>
    </div>
  </sweet-modal>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  props: {
    isChangeShift: {
      default: false
    }
  },
  data () {
    return {
      message: 'No data',
      shiftWorkTypeSelected: null,
      roleSelected: '',
      roleOptions: [
        { item: 'beneat_customer', name: 'BeNeat Customer' },
        { item: 'beneat_provider', name: 'BeNeat Provider' }
      ]
    }
  },
  computed: {
    ...mapState({
      shift_work_types: state => state.general.shift_work_types,
      admin: state => state.admin.admin
    }),
    currentShiftWork () {
      let shiftWorkType = ''
      if (this.admin && this.admin.shift_work_admin && this.admin.shift_work_admin.shift_work_type_id) {
        shiftWorkType = this.shift_work_types.find(item => item.id === this.admin.shift_work_admin.shift_work_type_id)
        shiftWorkType = shiftWorkType ? shiftWorkType.name : ''
      }
      return shiftWorkType
    }
  },
  methods: {
    async submitShiftWorkType () {
      if (!this.shiftWorkTypeSelected) {
        this.$swal({
          text: 'กรุณาเลือกกะการทำงาน',
          type: 'warning'
        })
      }

      let params = {
        shift_work_type_id: this.shiftWorkTypeSelected,
        admin_id: this.admin.beneat_admin_id,
        role: this.roleSelected
      }

      let url = '/shift-work-admin'
      let METHOD = 'post'
      // if (this.isChangeShift) {
      //   METHOD = 'put'
      //   url = '/shift-work-admin/' + this.admin.id
      // }

      const { data } = await axios[METHOD](url, params)
      this.$refs['modal-shift-work'].close()
      if (data.error) {
        await this.$swal({
          text: 'ผิดพลาด ' + data.message,
          type: 'error'
        })
      }
      if (data.shift_work_admin) {
        await this.$store.commit('admin/ADD_PROPERTY_ADMIN', {
          key: 'shift_work_admin',
          value: data.shift_work_admin
        })
        await this.$store.commit('admin/ADD_PROPERTY_ADMIN', {
          key: 'shift_work_role',
          value: data.shift_work_admin.role
        })
      }
    },
    openModal () {
      this.roleSelected = ''
      this.shiftWorkTypeSelected = null
      this.$refs['modal-shift-work'].open()
    }
  }
}
</script>

<style lang="scss" scoped>

div.panel-body {
  div.radio-box {
    margin-top: 10px;
  }

  .form-group input[type="radio"],
  .form-group input[type="checkbox"] {
    display: none;
  }

  div.radio-box div.btn-group {
    width: 100%;

    label {
      text-align: left;
    }
  }

  .form-group input[type="checkbox"] + .btn-group > label,
  .form-group input[type="radio"] + .btn-group > label {
    white-space: normal;
    min-width: 120px;
    font-size: 16px;
  }

  .form-group input[type="checkbox"] + .btn-group > label.btn-default,
  .form-group input[type="radio"] + .btn-group > label.btn-default {
    color: #333;
    background-color: #fff;
    border-color: #ccc;
  }

  .form-group input[type="radio"] + .btn-group > label svg:first-child,
  .form-group input[type="checkbox"] + .btn-group > label svg:first-child {
    display: none;
  }

  .form-group input[type="radio"] + .btn-group > label svg:first-child + svg,
  .form-group input[type="checkbox"] + .btn-group > label svg:first-child + svg {
    display: inline-block;
  }

  .form-group input[type="radio"]:checked + .btn-group > label svg:first-child,
  .form-group input[type="checkbox"]:checked + .btn-group > label svg:first-child {
    display: inline-block;
  }

  .form-group input[type="radio"]:checked + .btn-group > label svg:first-child + svg,
  .form-group input[type="checkbox"]:checked + .btn-group > label svg:first-child + svg {
    display: none;
  }

  .form-group input[type="checkbox"] + .btn-group > label i[class*="fas-"],
  .form-group input[type="checkbox"] + .btn-group > label i[class*="far-"],
  .form-group input[type="radio"] + .btn-group > label i[class*="fas-"],
  .form-group input[type="radio"] + .btn-group > label i[class*="far-"] {
    width: 15px;
    float: left;
    margin: 4px 0 2px -2px;
  }

  .form-group input[type="checkbox"] + .btn-group > label span.content,
  .form-group input[type="radio"] + .btn-group > label span.content {
    margin-left: 10px;
  }
}
</style>
